import { RouterProvider } from '@tanstack/react-router'
import { AppProviders } from './providers/AppProviders'
import { router } from './router/router'
import { AuthTokenBootstrap } from '@/features/auth'

export function App() {
  return (
    <AppProviders>
      <AuthTokenBootstrap>
        <RouterProvider router={router} />
      </AuthTokenBootstrap>
    </AppProviders>
  )
}
